<script>
  // A quest's base award: its store item reward when the row has one
  // (`row.reward_adventure`), else the points `value` like the points renderer.
  import Badge from '../../ui/badge.svelte'
  import Points from './points.svelte'

  let { value, row, column = {} } = $props()
  const reward = $derived(row?.reward_adventure)
</script>

{#if reward}
  <Badge variant="warning" soft size="sm" icon="reward" class="max-w-56" title={`Reward: ${reward.pre_purchase_title ?? ''}`}>
    <span class="truncate">{reward.pre_purchase_title}</span>
  </Badge>
{:else}
  <Points {value} {column} />
{/if}
